import { Component, Input, OnInit } from '@angular/core';
import { MenuGroup } from '../../dynamic-input-model';
import { NbMenuService, NbTabComponent } from '@nebular/theme';

@Component({
  selector: 'ngx-blog-editor-input',
  templateUrl: './blog-editor-input.component.html',
  styleUrls: ['./blog-editor-input.component.scss']
})
export class BlogEditorInputComponent implements OnInit {
  @Input() data:any;
  defaultMenuTag:string; 
  topLevelMenuTag = "editBlogsPageRouteMenu";
  activeInputMenuItem:string;
  defaultInputMenuItem:string;
  menuItemTitle:string;
  menuGroups:any;
  
  constructor(private menuService:NbMenuService) { }

  ngOnInit(): void {
    console.log(this.data);
    this.menuGroups = this.data;
    let topLevelMenu:MenuGroup = this.menuGroups["topLevelMenu"];

    if(topLevelMenu != undefined){
      this.defaultMenuTag = topLevelMenu.menuTag;
      this.defaultInputMenuItem = topLevelMenu.menuItems[0].title;
      this.activeInputMenuItem = this.defaultInputMenuItem;
    }
    this.menuService.onItemClick().subscribe(menuBag =>{
      console.log({menuBag:menuBag});
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        //if(selectedItem.parent.title)
        console.log({selectedItem:selectedItem});
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

  tabChanged(e:NbTabComponent){
    if(e.tabTitle == "Sections"){
        
    }
  }

}
